export enum DBEntityNameCodes {
  ManagedUpdates = 1,
  Tags = 2,
  OffenseType = 3,
  RejectionReasonType = 4,
  SeriousOffenseReasonsType = 5,
  SavedFiltersTemplates = 6,
  DecisionType = 7,
}
